<template>
  
  <notifications position="top right" classes="vue-notification" />
  <div>
    <router-view />
  </div>

</template>

<script>
import api from "./services/WebService";
import $ from "jquery"
export default {
  name: "App",
  mounted() {
    $(document).ready(function () {
      $(
        ".floating-form-group input,.floating-form-group textarea,.floating-form select"
      ).change(function () {
        if ($(this).val() != "") {
          $(this).addClass("filled");
        } else {
          $(this).removeClass("filled");
        }
      });
    });

    api.setLocale(this.$i18n);
  },
};
</script>

<style>
.vue-notification{
  margin-top: 100px !important;
}
</style>